export enum AccessRight {
  owner = 1,
  manager = 2,
  observer = 3
}
